import type { FocusState } from "../state/store";
import type { Storm } from "../engine/types";
import ExplorerPanel from "./ExplorerPanel";

const titleCase = (s: string) =>
  s === "UNNAMED" ? "Unnamed" : s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

// Pre-2004: track-only summary from the data we DO have (no fingerprint/footprints).
function TrackStats({ track }: { track: Storm }) {
  const oni = track.oni_anomaly;
  return (
    <div className="panel">
      <div className="live-header">
        <h3 style={{ margin: 0 }}>🌀 {titleCase(track.name)} ({track.year})</h3>
        <span className="badge archive">PRE-2004</span>
      </div>
      <div className="row" style={{ marginTop: 10 }}>
        <div className="metric"><div className="muted xs">Peak Category</div>{track.ss_category}</div>
        <div className="metric"><div className="muted xs">Peak Winds</div>{track.peak_vmax} kt</div>
        <div className="metric"><div className="muted xs">Min Pressure</div>{track.min_pmin} mb</div>
      </div>
      <div className="row">
        <div className="metric"><div className="muted xs">ENSO</div>{track.enso_state}</div>
        <div className="metric"><div className="muted xs">Peak ONI</div>{oni != null ? `${oni >= 0 ? "+" : ""}${oni.toFixed(1)}` : "—"}</div>
      </div>
      <div className="metric" style={{ marginTop: 10 }}>
        <div className="muted xs">Detail availability</div>
        <span style={{ fontSize: 13 }}>
          High-fidelity Threat Fingerprint &amp; impact footprints are available for <b>2004+</b> storms.
          This storm shows its track + summary only.
        </span>
      </div>
    </div>
  );
}

interface Props {
  focus: FocusState;
  onClose: () => void;
}

export default function FocusPanel({ focus, onClose }: Props) {
  return (
    <div>
      <button className="focus-back" onClick={onClose}>← Back to map</button>
      {focus.loading && <div className="panel"><div className="muted sm">Loading replay…</div></div>}
      {focus.source === "replay" && focus.replay && (
        <ExplorerPanel replay={focus.replay} hour={focus.hour} loading={false} />
      )}
      {focus.source === "track" && focus.track && <TrackStats track={focus.track} />}
      {focus.source === null && !focus.loading && (
        <div className="panel"><div className="muted sm">Storm detail unavailable.</div></div>
      )}
    </div>
  );
}
